import type { FeatureConfig } from '@skynet/feature-config';
import { NotificationOutlined } from '@ant-design/icons';
import { SMM_POST_ROUTE_PATH, SMM_POSTS_URL, SMM_ROUTE_PATH } from './routes';

/**
 * Feature manifest for the admin social media (SMM) posts page. The dashboard
 * shell reads this single source of truth instead of hardcoding the route,
 * navigation entry, header label and Cerbos action across its routing,
 * navigation, header and access-control modules.
 *
 * `route.load` and `detailRoute.load` are dynamic-import thunks, so importing
 * this config for its nav/header metadata never pulls the page implementation
 * into the main bundle. `detailRoute` is a single social post: the
 * review/approve view or the publish status, depending on the post's `status`.
 *
 * The SMM pages talk to the assistant-smm REST API only, so they skip the
 * WebSocket login (the skip path is a prefix, so it covers the post pages too).
 */
export const smmConfig = {
  domain: 'Admin',
  section: 'smm',
  route: {
    path: SMM_ROUTE_PATH,
    load: async () => ({ default: (await import('./SmmPostsPage')).SmmPostsPage }),
  },
  detailRoute: {
    path: SMM_POST_ROUTE_PATH,
    load: async () => ({ default: (await import('./SmmPostPage')).SmmPostPage }),
  },
  nav: {
    key: 'admin.smm',
    label: 'Social media',
    icon: <NotificationOutlined />,
    url: SMM_POSTS_URL,
  },
  header: { label: 'Social media' },
  cerbosAction: 'read:admin:smm',
  needsEntityId: false,
  skipWsLoginPaths: [SMM_POSTS_URL],
} as const satisfies FeatureConfig;
